export enum ICON_TYPE {
  CLOSE_LIGHT = 'CLOSE_LIGHT',
}
